import { useTranslation } from "react-i18next";
import { localizedProps } from "src/utils/localize";

// ДЕПОЗИТ — взнос за бронь места в группе.
//
// Блок намеренно заметный: это главное возражение покупателя («а вдруг не дадут
// визу») и одновременно ответ на него — остаток платится только после визы.
// Пустой `deposit` = блока нет.
export default function DepositBlock({ deposit, depositNote, className = "" }) {
  const { t, i18n } = useTranslation();
  const note = localizedProps(depositNote, i18n.language);

  if (!deposit) return null;

  return (
    <section
      className={`rounded-xl border border-kj-gold/40 bg-kj-gold/[0.08] p-4 sm:p-5 ${className}`}
    >
      <h3 className="text-xs font-bold uppercase tracking-[0.12em] text-kj-sub">
        {t("tour.depositTitle")}
      </h3>
      <p className="mt-1.5 flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <span className="text-2xl sm:text-3xl font-extrabold text-kj-gold tabular-nums">
          {deposit}
        </span>
        <span className="text-sm text-kj-sub">{t("tour.depositHint")}</span>
      </p>
      {note.value && (
        <p {...note.attrs} className="mt-3 text-sm text-kj-sub leading-relaxed">
          {note.value}
        </p>
      )}
    </section>
  );
}
